import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function($) {
  if (!$('.oriented').length) {
    return;
  }

  businessOriented($);
});

function businessOriented($) {
  if ($(window).width() <= 800) {
    $('.oriented-list .list-box').addClass('swiper-wrapper');
    new Swiper('.oriented-list', {
      spaceBetween: 10,
      slidesPerView: 1,
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/business-oriented.js